import React from 'react';
import logo360 from './360logo.svg';
import paidBannerImg from '../../../assets/images/diet-banner-paid-img.jpg';

const PaymentHeader = () => {
    return(
        <div className='position-relative mb-4'>
            <img src={paidBannerImg} className='w-100' alt="" />
            <div className='payment-header-absolute'>
                <img className='mt-5' src={logo360} alt="" />
                <h2 className='mt-1 mb-0 payment-title'>Unlock your health</h2>
                <p className='mb-0 payment-subtext pb-0'> Expert nutritionist coaching. <br/>Powered by Dr Trust 360.</p>
            </div>
        </div>
    );
}

export default PaymentHeader;